<template>
  <div id="btnsWrap">
    <ul>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">A.桜木町</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">B.汽車道</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">C.ﾜｰﾙﾄﾞﾎﾟｰﾀｰｽﾞ</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">D.ｺｽﾓﾜｰﾙﾄﾞ</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">E.ｶｯﾌﾟﾇｰﾄﾞﾙﾐｭｰｼﾞｱﾑ</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">F.中華街</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">G.赤ﾚﾝｶﾞ倉庫</div></li>
      <li class="frame-outer" :style="pinkFrame"><div class="inr" @click.stop="onSelect">H.港の見える丘公園</div></li>
    </ul>
    <div class="frame-outer" :style="judgeFrame">
      <div class="inr" @click.stop="onClickJudge">決定</div>
      <div class="arrow " :style="arrowStyle"></div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'ShiroganeQ4',
    props: {
    },
    data() {
      return {
        // publicPath: process.env.BASE_URL,
        pinkFrame: {
          backgroundImage: 'url(./img/common/pink_frm02_358_t.png),url(./img/common/pink_frm02_358_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)'
        },
        grayFrame: {
          backgroundImage: 'url(./img/common/gray_frm02_358_t.png),url(./img/common/gray_frm02_358_b.png), url(./img/common/gray_frm02_l.png), url(./img/common/gray_frm02_r.png)'
        },
        whiteFrame: {
          backgroundImage: 'url(./img/common/white_frm02_358_t.png),url(./img/common/white_frm02_358_b.png), url(./img/common/white_frm02_l.png), url(./img/common/white_frm02_r.png)'
        },
        arrowStyle: {
          backgroundImage: 'url(./img/common/white_arw.png)'
        },
        judgeFrame: {},
        judgeBtnFlag: false,
        timer: null
      }
    },
    mounted() {
      // this.blinkArrow()
      this.judgeFrame = this.grayFrame
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
    },
    methods: {
      onSelect: function(e){
        let btn = _$(e.target).parents('li')
        btn.toggleClass('selected')

        let judgeBtn = _$('#btnsWrap > div')
        let chkJudgeBtn = false

        for(let i=0; i<_$('li').length; i++){
          if(_$('li').eq(i).hasClass('selected')){
            chkJudgeBtn = true
            break;
          }
        }

        if(chkJudgeBtn){
          judgeBtn.addClass('enable')
          this.judgeFrame = this.whiteFrame
          if(!this.judgeBtnFlag){
            this.judgeBtnFlag = true
            this.blinkArrow()
          }
        } else {
          judgeBtn.removeClass('enable')
          this.judgeFrame = this.grayFrame
          this.judgeBtnFlag = false
          this.stopTimer()
        }
      },
      onClickJudge: function(){
        let result = 'correct'

        for(let i=0; i<_$('li').length; i++){
          if(!_$('li').eq(i).hasClass('selected')){
            result = 'badend'
            break
          }
        }

        this.$emit('judgeAns', result);
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#btnsWrap .arrow').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
        _$('#btnsWrap .arrow').show()
      }
    }
  }
</script>

<style lang="scss" scoped>
  #btnsWrap {
    height: toVW(532);
    margin: toVW(32) toVW(13) toVW(13);
    display: flex;
    flex-flow: row wrap;
    align-items: center;

    .frame-outer {
      background-position: left top, left bottom, left top, right top;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-size: toVW(358) auto, toVW(358) auto, toVW(15) auto, toVW(15) auto;
      width: toVW(358);
      height: toVW(100);
      position: relative;

      .inr {
        width: 100%;
        height: 100%;
        text-align: center;
        padding: toVW(40);
        line-height: toVW(20);
        letter-spacing: .07em;
      }
    }

    ul {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;

      li.frame-outer {
        margin-top: toVW(8);
        flex-shrink: 0;

        &:nth-child(-n+2){
          margin-top: 0;
        }

        &.selected {
          background-color: $COLOR_PINK01;
        }

        .inr {
          text-align: left;
          padding-left: toVW(45);
        }
      }
    }

    > div {
      margin: toVW(8) auto 0;
      color: #545454;
      pointer-events: none;

      .arrow {
        background-repeat: no-repeat;
        background-size: contain;
        width: toVW(21);
        height: toVW(28);
        position: absolute;
        top: calc((100% - 3.733vw) / 2);
        left: toVW(37);
        opacity: 0.47;
      }

      &.enable {
        color: #fff;
        pointer-events: auto;

        .arrow {
          opacity: 1;
        }
      }
    }
  }
</style>
